<template>
  <div class=''>

    <Nav ref="navRef" :rType="1" @routerType="changePage"></Nav>
    <div style="height: 80px"></div>
    <div class="home " >
      <div class="home-bottom" v-if="Data">
        <!-- 直播画面 -->
        <div class="my_videoList " v-if="routerIndex == 1">
          <div class="home-right-top " :class="{'filterbgs':grayTheme}" :style="{
              'background-image':
                'url(https://oss.ansongqiubo.com/prd/banner/banner_top.png' +
                '?timestamp=' +
                imageTime +
                ')',
            }">
            <!-- 顶部tabs -->
            <div class="tabs_header">
              <div @click="changeTabs(items)" class="itemtabs"
                :class="items.categoryId == currenttabs ? 'activetabs' : ''" v-for="(items, index) in categories"
                :key="index">
                <span>
                  {{ items.categoryName }}
                </span>
              </div>
            </div>
            <!-- 视频播放器 -->
            <div class="video_hander">
              <div v-if="source" class="bofangqi">
                <ali-player ref="player" v-if="source"
                  @liveStreamStop="liveStreamStop($event)" :autoplay="true"  :rePlay="false"
                  showBuffer="true" showBarTime="5000" format="flv" :source="source">
                </ali-player>
                <!-- 鼠标移入移出进入直播间 -->
                <div v-if=" shouyetabsData &&  shouyetabsData[zhiboIndex]"
                  class="videoMovieinto" @click="Jinruzhibojian(shouyetabsData[zhiboIndex].live.id,shouyetabsData[zhiboIndex].live.stream.flv,shouyetabsData[zhiboIndex].item.virtualId ) ">
                  <span>进入直播间</span>
                </div>
              </div>
              <!-- 视频切换栏目 -->
              <ul v-if="shouyetabsData && shouyetabsData.length >0">
                <li v-for="(item, index) in shouyetabsData" v-if="index < 5" :key="index"
                  @click="Zhibo(index, item.live.stream.flv)" :class="{ zhibo: zhiboIndex == index }">
                  <img v-if="item.item.cover" :src="item.item.cover" alt="" />
                </li>
              </ul>
            </div>
          </div>
          <!-- 主播招募 -->
          <!-- <div class="home_banner">
            <div class="banner_xuanchan" @click="navxuanchan">
              <img src="/static/home/banner1.png" alt="" srcset="" />
            </div>
          </div> -->
          <!-- 直播比分 -->
         <div style="display: flex;justify-content: center;margin-top: 24px;" class="home-right">
            <homeScore></homeScore>
          </div>
          <!-- 弹窗广告 -->
          <div v-if="!token && !isHomeshowDialogs">
            <animalDialog  @login='emitLongin' @closeMask='closeMask'></animalDialog>
          </div>
            <!-- 人气榜 -->
          <div class="myhotVideo "  :class="{'filterbgs': grayTheme }" style="margin-top: 50px;">
            <div class="myhotContent">
              <hotPerson  @emitLongin="emitLongin" ></hotPerson>
            </div>
          </div>
          <div class="home-right"  :class="{'filterbgs': grayTheme }">
            <div class="centerData">
              <!-- banner -->
              <div class="mylista " :class="bannerList.length !=0?'hots':''">
                <div class="home-right-bottom" style="width: 796px;">
                  <div class="banner_swipers" style="border-radius: 6px;overflow: hidden;" v-if="bannerList.length>0">
                    <el-carousel height="238px">
                      <el-carousel-item v-for="(item,index) in bannerList" :key="index">
                        <img style="border-radius: 8px;" :src="item.image" alt="" srcset="" @click="bannerTo(item)">
                      </el-carousel-item>
                    </el-carousel>
                  </div>
                  <!--  明星主播 -->
                  <div class="start_bang">
                    <div class="start_list">
                      <div class="title_headers">
                        <img class="title_img" src="https://oss.ansongqiubo.com/static/home/start.png" alt="" srcset="" />
                        <div class="">明星主播</div>
                      </div>
                      <div class="userstart">
                        <div class="start_item" v-if="items.user.uid &&  homerankStartlist.list.length > 0"
                          @click="navToUser(items.user.uid, items.live.id>0?1:0,items.item.virtualId)"
                          v-for="(items,index) in homerankStartlist.list" :key="index">
                          <div class="live_imgstatus">
                            <div class="hiddens">
                              <img :src="items.user.avatar" style="border-radius:50%" srcset="" />
                            </div>
                            <img v-if=" items.live.id>0" src="https://oss.ansongqiubo.com/static/home/live.gif" class="gift" alt="" srcset="">
                          </div>
                          <div class="start_name">{{items.user.nickname}}</div>
                          <div class="start_catgray">{{items.category.categoryName?items.category.categoryName:'-'}}</div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <!-- 咨询数据 -->
                <div class="rankingList">
                  <myarticle></myarticle>
                </div>
              </div>
            </div>
          </div>
          <!-- 热门主播 -->
          <div class="home-right"  :class="{'filterbgs': grayTheme }" v-if="shouyeData && shouyeData.list ">
            <div class="centerData" v-show="shouye">
              <div class="home-right-center">
                <div class="title_img">
                  <img src="https://oss.ansongqiubo.com/assets/home/icon_remenzhibo@2x.png" alt="" />
                </div>
                <div class="title">热门直播</div>
                <div class="moredata">
                  <div class="title" @click="navmore">更多直播</div>
                  <div class="more_icon">
                    <img src="https://oss.ansongqiubo.com/assets/home/icon_jt_R@2x.png" alt="" srcset="" />
                  </div>
                </div>
              </div>
              <!-- 底部视频列表 -->
              <div class="mylista tuijian">
                <div class="home-right-bottom" v-if="shouyeData.list && shouyeData.list.length > 0">
                <div class="home-right-bottomItem" v-for="(item, index) in shouyeData.list" :key="index" v-if="index < 8 "
                    :class="index>3?'nobottom':''">
                  <liveItem @login='emitLongin' :liveDetailitems='item'></liveItem>
                </div>
                </div>
              </div>
            </div>
          </div>
          <!-- 直播推荐 -->
          <div class="home-right"  :class="{'filterbgs': grayTheme }" v-if="shouyeData && shouyeData.list && shouyeData.list.length > 7">
            <div class="centerData" v-show="shouye">
              <div class="home-right-center">
                <div class="title_img">
                  <img src="https://oss.ansongqiubo.com/assets/home/icon_zhibotuijian@2x.png" alt="" />
                </div>
                <div class="title">直播推荐</div>
                <div class="moredata">
                  <div class="title" @click="navmore">更多直播</div>
                  <div class="more_icon">
                    <img src="https://oss.ansongqiubo.com/assets/home/icon_jt_R@2x.png" alt="" srcset="" />
                  </div>
                </div>
              </div>
              <!-- 底部视频列表 -->
              <div class="mylista tuijian" style="
                margin-bottom: 24px;
                ">
                <div class="home-right-bottom" v-if="shouyeData.list && shouyeData.list.length > 0">
                <div class="home-right-bottomItem"  v-for="(item, index) in shouyeData.list" :key="index"
                    v-if="index > 7 && index <20" :class="index>15?'nobottom':''" >
                  <liveItem @login='emitLongin' :liveDetailitems='item'></liveItem>
                </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div v-if="true" class="bottom_footers"  :class="{'filterbgs': grayTheme }" style="
        height: 140px;
        margin-top: 10px;
        box-sizing: border-box;
        padding: 20px 0;
      ">
      <div style="
          height: 20px;
          text-align: center;
          font-size: 12px;
          display: flex;
          align-items: center;
        ">
        <div><a>江苏聚一唐网络科技有限公司  </a> |</div>
        <div>
          <img style="width: 20px; height: 20px" src="https://oss.ansongqiubo.com/Image/beian/2.png" alt="" />
        </div>

        <div>
        <a href="https://beian.miit.gov.cn/#/Integrated/index" target="_blank"> 苏ICP备 2202033170号</a>| <a href="http://cyberpolice.mps.gov.cn"
            style=" text-decoration: none">网络违法举报网站</a>
        </div>
      </div>
      <div style="margin-left:12px;font-size: 12px;">
        <a  style="height:20px;width:100%;text-align: center;color: #999;font-size:12px;" href="https://www.baidu.com"  target="_blank">百度一下</a> | <a  style="height:20px;width:100%;text-align: center;color: #999;font-size:12px;" href="https://aizhan.com"  target="_blank">站长工具</a>
      </div>
    </div>
  </div>
</template>
<script>
  import liveItem from "@/components/lz_liveItem.vue";
  import aliplayer from "../components/aliplayer.vue";
  // import aliplayer from "../components/bofangqi2.vue";
  // 引入文章模块
  import myarticle from '@/pages/template/newactice.vue'
  // 引入比分模块
  import homeScore from '@/pages/template/homescore.vue'
  // 弹窗广告
  import animalDialog from '@/pages/components/lz_animalDialog.vue'
  import hotPerson from '@/pages/template/template_hotlist.vue'
  import {getQueryString} from '@/lib/tools.js'
  import Nav from "../component/Nav.vue";
  import axios from "axios";
  import qs from "qs";
  import {
    homerank,
    banners
  } from '../api/lz.js'
  import { myLocalStorage } from '@/lib/tools.js'
  export default {
    inject: ["reload"],
    data() {
      return {
        token:'',
        bannerList: [],
        homerankStartlist: [],
        homeranklist: [],
        shouyetabsData: [],
        fristvideoList:[],
        currenttabs: 0, // 默认选择
        categories: [], // 视频分类列表
        careList: [], // 关注列表
        referenTime: null,
        routerIndex: 1,
        zhiboIndex: 0,
        zhiboIndexx: "",
        Data: [],
        fenlei1: 0,
        shouye: true,
        fenlei: false,
        shouyeData: [], //首页数据
        source: "", //直播拉流地址
        isLive: true, //直播
        instance: null,
        pcatId: 1, //分类参数
        imageTime: "", //image时间戳
        isHomeshowDialogs:true, // 是否显示弹窗广告
      };
    },
    computed:{
      grayTheme(){
        let data = JSON.parse(localStorage.getItem('userSettingInfo') || {}) ; // grayTheme
        return data && data.grayTheme
      }
    },
    mounted() {
      location.href = '/v2';
      return
      
      let self = this;
      this.imageTime = Date.parse(new Date()) / 1000;
      document.addEventListener("visibilitychange", function() {
        if (document.visibilityState == "hidden") {
          console.log('离开到该页面');
          //切离该页面时执行
        } else if (document.visibilityState == "visible") {
          //切换到该页面时执行
          console.log('切换到该页面');
            self.streams();
            // 刷新人气榜
            self.initData();
            return
        }
      });
      this.initData();
      this.streams();
    },
    // 初始化请求
    activated(){
      console.log('初始化请求');
    },
    created() {
      this.$store.dispatch('getSettingInfo').then(result=>{
        console.log('获取配置信息',result);
      })
      this.token = localStorage.getItem("token");
      if( this.token ){
        this.getcareList(2);
      }
    },
    filters: {
      ellipsis(value) {
        if (!value) return "";
        if (value.length > 10) {
          return value.slice(0, 10) + "...";
        }
        return value;
      },
      nameFilters(value) {
        if (!value) return "";
        if (value.length > 10) {
          return value.slice(0, 10) + "...";
        }
        return value;
      },
    },
    methods: {
      closeMask(){
        this.isHomeshowDialogs = true
        console.log('关闭了吗',this.isHomeshowDialogs );
      },
      emitLongin() {
        this.$refs.navRef.Longin();
      },
      changeTabs(items) {
        this.currenttabs = items.categoryId;
        this.pcatId = items.categoryId;
        this.zhiboIndex = 0;
        this.streams();
      },
      // banner图跳转
      bannerTo(item) {
        console.log('banner跳转', item)
        if(item.href){
           window.open(item.href, "_blank");
        }
      },
      initData() {
        this.isHomeshowDialogs = false

        const that = this;

        // 分类列表
        that.$axios
          .get(that.api + "/v1/list/categories", {
            params: {},
            headers: {
            },
          })
          .then((res) => {
            // console.log(res);
            that.categories = []
            if (res.data.code == 200) {
              that.Data = res.data.data;
              that.Data.map((item) => {
                if (item.lives > 0) {
                  that.categories.push(item);
                }
              });
              console.log("我的分类", this.categories);
              if (this.categories.length > 0)
                this.currenttabs = this.categories[0].categoryId;
            } else {
              that.categories = [];
            }
          });
        // 人气榜
        homerank({
          rankType: 'popular',
          pageIndex: 5,
        }).then(res => {
          if (res.data.code == 200) {
            this.homeranklist = res.data.data
          }
        })
        // 明星榜
        homerank({
          rankType: 'star',
          pageIndex: 5,
        }).then(res => {
          if (res.data.code == 200) {
            this.homerankStartlist = res.data.data
          }
        })
        this.getBanners()
      },
      getBanners(){

        //
        const params = myLocalStorage.get('bannerList','home')
        if(!params){
          // 轮播图
          banners({
            pcatId: 1
          }).then(res => {
            if (res.data.code == 200) {
              this.bannerList = res.data.data;
              myLocalStorage.set('bannerList','home', this.bannerList);
            }
          })
        }else{
          this.bannerList = params;
        }




      },
      isCare(uid) {
        let arr = this.careList.filter((item) => item.uid == uid);
        if (arr && arr.length > 0) {
          return true;
        } else {
          return false;
        }
      },
      // 关注主播
      guanzhu(val, state) {
        if(!this.token){
          this.$refs.navRef.Longin();
          return
        }
        if (state) {
          axios({
            headers: {
              device: "iOS",
              packageId: "1",
              version: "1.0.0",
              "authToken":localStorage.getItem("token"),
              "Content-Type": "application/x-www-form-urlencoded",
            },
            transformRequest: [
              function(data) {
                //在请求之前对data传参进行格式转换
                data = qs.stringify(data);
                console.log(data);
                return data;
              },
            ],
            url: this.api + "/v1/relation/follow",
            method: "post",
            data: {
              actionUid: val.uid,
            },
          }).then((res) => {
            if(res.data.code == 200){
              this.$message({
                message: "关注成功",
                type: "success",
              });
              this.getcareList(2);
              console.log("关注主播", res);
            }else{
              this.$message({
                message:res.data.message,
                type: "error",
              });
            }
          });
        } else {
          this.$confirm("取关该主播将无法及时收到消息, 是否取关?", "温馨提示", {
              confirmButtonText: "确定",
              cancelButtonText: "取消",
              type: "warning",
            })
            .then(() => {
              axios({
                headers: {
                  device: "iOS",
                  packageId: "1",
                  version: "1.0.0",
                  "authToken": localStorage.getItem("token"),
                  "Content-Type": "application/x-www-form-urlencoded",
                },
                transformRequest: [
                  function(data) {
                    data = qs.stringify(data);
                    console.log(data);
                    return data;
                  },
                ],
                url: this.api + "/v1/relation/unfollow",
                method: "post",
                data: {
                  actionUid: val.uid,
                },
              }).then((res) => {
                console.log(res);
                this.$message({
                  message: "取关成功",
                  type: "success",
                });
                if (this.first_soft == 99) {
                  this.getcare();
                } else {
                  this.getcareList(2);
                }
              });
            })
            .catch(() => {});
        }
      },
      getcare() {
        this.first_soft = 99;
        this.shouyeData = [];
        this.$axios
          .get(this.api + "/v1/relation/lives", {
            params: {
              pageIndex: 0,
            },
            headers: {
              device: "web",
              packageId: "1",
              channel: "web",
              version: "1.0.0",
              "authToken": localStorage.getItem("token"),
              "Content-Type": "application/x-www-form-urlencoded",
            },
          })
          .then((res) => {
            console.log("关注列表", res);
            this.$router.push({
              query: merge({ rid: 3, infoId: this.first_soft, valId: "" }),
            });
            this.shouyeData = res.data.data;
          });
      },
      // 获取关注列表
      async getcareList(type=1) {
       this.token = localStorage.getItem("token");
       if (this.token){
         let list = await this.$store.dispatch('getUserFollowData',type);
         console.log('我的关注列表·',list);
         this.careList = list;
       }
      },
      pageRouter(query){
        this.$store.commit('pageRouter',{
          type:1,
          query,
        })
      },
      // 跳转关于我们
      navAbout(e) {
        this.pageRouter({ path: "/about", query: {
            rid: 1,
            infoId: 0,
            valId: 1
          },
        })
      },
      navxuanchan() {
        window.open('https://www.zhuayuzhibo.tv/', "_blank");
      },
      beianurl(val) {
        this.pageRouter({
          path: '/website',
          query: {
            rid: 1,
            infoId: val,
            valId: 1
          }
        })
      },
      navmore() {
        this.pageRouter({
          path: "/pageLive",
          query: {
            rid: 1,
            infoId: 1,
            valId: ''
          },
        })
      },
      //
      navToUser(uid, like,virtualId) {
          // if(localStorage.getItem('token')){
            if (like == 1) {
              this.pageRouter({
                path: "/roominfo",
                query: {
                  roomId: uid,
                  virtualId
                },
              })
            } else {
              this.$router.push({
                path: "/yonghuyemian",
                query: {
                  uid: uid
                },
              });
            }
          // }
      },
      // 悬浮功能
      navhelp(e) {
        console.log("e :>> ", e);
        if (e == 5) {
          this.backtop();
        }
        if (e == 4) {
          this.$router.push({ path: "/tianjiazhiboyuan?id=8&tab=2" });
        }
      },

      backtop() {
        /**
         * 回到顶部功能实现过程：
         * 1. 获取页面当前距离顶部的滚动距离（虽然IE不常用了，但还是需要考虑一下兼容性的）
         * 2. 计算出每次向上移动的距离，用负的滚动距离除以5，因为滚动的距离是一个正数，想向上移动就是做一个减法
         * 3. 用当前距离加上计算出的距离，然后赋值给当前距离，就可以达到向上移动的效果
         * 4. 最后记得在移动到顶部时，清除定时器
         */
        var timer = setInterval(function() {
          let osTop =
            document.documentElement.scrollTop || document.body.scrollTop;
          let ispeed = Math.floor(-osTop / 5);
          document.documentElement.scrollTop = document.body.scrollTop =
            osTop + ispeed;
          this.isTop = true;
          if (osTop === 0) {
            clearInterval(timer);
          }
        }, 10);
      },
      // 切换路径
      changePage(e) {
        this.routerIndex = e;
        // 3 直播
        if (e == 3) {
          this.$router.push("/pageLive");
        }
      },
      streams() {
        // 对应分类列表的数据流
        this.$axios
          .get(this.api + "/v1/list/streams", {
            params: {
              pcatId: this.pcatId,
              pageIndex: 0,
            },
            headers: {
              device: "web",
              packageId: "1",
              channel: "web",
              version: "1.0.0",
            },
          })
          .then((res) => {
            if(res.data.code == 200 &&  res.data.data.list){
               this.shouyeData = res.data.data;
               let list =   [... this.shouyeData.list];
               list = list.splice(0,5);
                list.sort(function () {
                 return Math.random() - 0.5
               })
               this.shouyetabsData = list
               console.log('首页流数据',this.shouyeData,list);
                if( list.length > 0 && list[0].live){
                 this.source = list[0].live.stream.flv;
                }
               setTimeout(() => {
                 this.$refs.player? this.$refs.player.loadByUrl(this.source):'';
               });
            }
          });
      },
      // 顶部分类的数据
      streams2() {
        // 对应分类列表的数据流
        if(this.shouyeData.list){
          let list =  JSON.parse(JSON.stringify(this.shouyeData.list));
          this.shouyetabsData = list.slice(0,5);
          this.shouyetabsData.sort(function () {
            return Math.random() - 0.5
          })
          this.$nextTick(() => {
            if (this.$refs.player) {
                console.log('开始加载直播播放器');
                this.source = this.shouyetabsData[0].live.stream.flv;
                this.$refs.player.loadByUrl(this.source);
            }
          });
        }
      },
      Jinruzhibojian(id, flv,virtualId) {
        const neww = this.$router.resolve({
          path: "/roominfo",
          query: {
            roomId: id,
            virtualId
          },
        });
        window.open(neww.href, "_self");


        this.$nextTick(() => {
          this.$refs.player?this.$refs.player.pause():'';
          this.$refs.player.$el.children[3].style.display = "inline";
        });
      },
      Shouye() {
        this.fenlei = false;
        this.shouye = true;
      },
      dianji() {
        window.location.href = "/";
      },
      Zhibo(index, flv) {
        this.$nextTick(() => {
          this.$refs.player.loadByUrl(flv);
          this.zhiboIndex = index;
        });
      },
      //直播出错恢复处理
      onM3u8Retry(event) {
        alert("主播暂时离开，请稍后......");
        this.closePlayer();
      },
      liveStreamStop(event) {

        if(this.source)
        this.closePlayer();
      },
      //关闭模态层
      closePlayer() {
        console.log('关闭模态框');
      },
    },
    components: {
      Nav,
      myarticle,
      homeScore,
      hotPerson,
      liveItem,
      "ali-player": aliplayer,
      animalDialog
    },
    destroyed() {
      clearInterval(this.referenTime);
      // this.$refs.player.pause();
    },
  };
</script>

<style scoped lang='scss'>
  @import "../assets/style/index.scss"; //引入全局scss
  /* 播放器去黑边 */
  .prism-player {
    background: rgba(0, 0, 0, 0.2) !important;
    text-align: center !important;
    /* min-height: 578px !important; */
  }

  .colorPlay {
    background-image: url(https://oss.ansongqiubo.com/Image/userimage/play.png);
  }

  .bottom_footers {
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;

    div {
      color: #999;
    }

    div p:hover {
      color: #d4b2ff;
    }

    a {
      text-decoration: none;
      cursor: pointer;
      color: #999;
    }

    a:hover {
      color: #672dd4;
    }
  }

  .a {
    background: #672dd4;
    color: white;
    /* font-size:1.5em; */
    /* height: 18px;
  width: 18px; */
  }

  .b {
    background: white;
    color: #000;
    font-size: 20px;
    border-radius: 4px;
  }

  .c {
    background-color: white !important;
  }

  .tubiao {
    margin-right: 15px;
  }

  .zhibo {
    /* width: 120%; */
    border: 3px solid #672dd4;
    /* box-sizing: border-box; */
    width: calc(95% +6px);
    height: calc(auto +6px);
  }

  .zhibo1 {
    /* width: 120%; */
    border: 3px solid #672dd4;
  }

  .home {
    width: 100%;
    min-height: 92vh;
    background: $bgNav;
    position: relative;
    font-size: 16px;
    overflow: hidden;
    // margin: 0 auto;
    display: flex;

    .home-right-div-title2 {
      display: flex;
      justify-content: space-between;
      flex: 2;
      align-items: center;

      .hotName {
        font-size: 14px;
        font-family: PingFangSC-Regular, PingFang SC;
        font-weight: 400;
        color: #666666;
        display: flex;
        align-items: center;

        img {
          margin-right: 2px;
          width: 11px;
          height: 11px;
        }
      }

      .name2 {
        font-size: 14px;
        font-family: PingFangSC-Regular, PingFang SC;
        font-weight: 400;
        color: #666666;
      }
    }
  }


  .bg-purple2>div {
    width: 31px;
    height: 31px;
    display: flex;
    justify-content: center;
    align-items: center;
    margin-left: 20px;
  }

  .bg-purple-light {
    display: flex;
    justify-content: center;
    align-items: center;
    background: #ffffff;
    margin-left: 506px;
  }

  .grid-content {
    /* border-radius: 4px; */
    height: 100%;
  }

  .row-bg {
    padding: 10px 0;
    background-color: #f9fafc;
  }

  .el-input {
    width: 85%;
    height: 100%;
    display: flex;
    justify-content: center;
    align-items: center;
    background-color: white;
  }

  .bg-purple-light-input {
    height: 48px;
    width: 523px;
    /* border-radius: 4px; */
    border-top-left-radius: 4px;
    border-bottom-left-radius: 4px;
    font-size: 18px;
    padding-left: 20px;
    border: none;
    background-color: rgba(239, 239, 239, 1);
    justify-content: center;
    align-items: flex-start;
    outline: none;
    /* margin: 6px 0 0 506px; */
  }

  .home-search {
    width: 80px;
    height: 48px;
    background: url(https://lanhu.oss-cn-beijing.aliyuncs.com/SketchPng2a77b47d81b017e22fa5957766e677d0ff1120b15951c7c17eb5685730ba6115) 100% no-repeat;
    border-top-right-radius: 4px;
    border-bottom-right-radius: 4px;
    display: flex;
    justify-content: center;
    align-items: center;
  }

  .my_videoList {
    width: 100%;
    display: flex;
    flex-direction: column;
    justify-content: center;
  }

  .home-bottom {
    width: 100%;
    height: 100%;
    /* overflow-y: scroll; */
    display: flex;
    background: #f7f8fa;
  }

  .home-left {
    /* height: 100%; */
    width: 160px;
    /* min-width: 170px; */
    background: $bgNav;
    color: #666;
  }

  .home-left>div {
    width: 100%;
    height: 52px;
    /* background: black; */
    display: flex;
    justify-content: center;
    align-items: center;
    cursor: pointer;
  }

  .home-right2 {
    background: $bgNav;

    box-sizing: border-box;
    padding: 20px;
    display: flex;
    flex-direction: column;
  }

  .start_bang {
    display: flex;
    justify-content: center;
    background: #f7f8fa;
    width: 100%;
    .start_list {
      width: 796px;
      height: 238px;
      background: #FFFFFF;
      margin-top: 12px;
      padding: 20px 50px 24px;
      box-sizing: border-box;
      border-radius: 6px;
      width: 100%;
      display: flex;
      justify-content: space-between;
      flex-direction: column;
      align-items: flex-start;
      .userstart{
        display: flex;
      }
      .start_item:last-child {
        margin-right: 0 !important;
      }

      .start_item:hover {
        transition: all .2s;
        .hiddens{
          width: 80px;
          border-radius: 50%;
          height: 80px;
          transition: all .2s;
          overflow: hidden;
          img{
            transform: scale(1.2);
            transition: all .2s;
          }

        }

      }
      .start_item {
        margin-right: 69px;
        display: flex;
        transition: all .2s;
        background-color: #fff;
        justify-content: center;
        flex-direction: column;
        align-items: center;
        background: #FFFFFF;
        border-radius: 6px;
        .hiddens{
          overflow: hidden;
          width: 80px;
          border-radius: 50%;
          transition: all .2s;
          height: 80px;
          img {
            transform: scale(1.05);
            width: 80px;
            height: 80px;
          }
        }
        .attention {
          margin-top:px;
          transition: all .2s;
          cursor: pointer;
          display: block;
          padding: 3px 9px;
          border-radius: 18px;
          background: linear-gradient(270deg, #F75325 0%, #ED1010 100%);
          color: #fff;
          font-size: 11px;
          text-align: center;
        }

        .careOk {
          margin-top:12px;
          cursor: pointer;
          display: block;
          padding: 3px 8px;
          border-radius: 18px;
          background: rgb(231, 231, 231);
          color: #fff;
          font-size: 11px;
          text-align: center;
        }

        .live_imgstatus {
          position: relative;
          width: 80px;
          height: 80px;

          img {
            width: 80px;
            height: 80px;
          }

          .gift {
            position: absolute;
            bottom: 4px;
            right: -2px;
            width: 28px;
            height: 28px;
          }
        }

        .start_catgray {
          font-size: 12px;
          margin-top: 6px;
          font-family: PingFangSC-Regular, PingFang SC;
          font-weight: 400;
          color: #666666;
        }

        .start_name {
          margin-top: 12px;
         font-size: 14px;
         font-family: PingFangSC-Regular, PingFang SC;
         font-weight: 400;
         color: #333333;
        }
      }

      .title_headers {
        display: flex;
        position: relative;
        align-self: center;
        width: 140px;
        height: 40px;
         /* background: linear-gradient(90deg, #B669E8 0%, #7932D2 100%); */
        .title_img{
            width: 140px;
            height: 40px;
        }
        div{
          font-size: 18px;
            word-break:keep-all;
           white-space:nowrap;
          font-family: PingFangSC-Regular, PingFang SC;
          font-weight: 400;
          color: #FFFFFF;
          text-align: center;
          left: 50%;
          top:46%;
          transform: translate(-50%,-50%);
          position: absolute;
        }
      }

      span {
        font-size: 20px;
        font-family: PingFangSC-Medium, PingFang SC;
        font-weight: 500;
        color: #333333;
      }

      .title_img {
        margin-right: 6px;
        width: 32px;
        height: 32px;
      }
    }
  }

  .today_vsdata {
    border-radius: 4px;
    overflow: hidden;
    max-width: 1200px;
    flex: 2;
    margin: 44px 0;
    display: flex;
    align-items: center;

    .today_now {
      width: 40px;
      height: 174px;
      background: #ffffff;
      display: flex;
      align-items: center;
      justify-content: center;
      flex-direction: column;

      img {
        width: 18px;
        height: 18px;
      }

      span {
        margin-top: 6px;
        display: inline;
        text-align: center;
        width: 18px;
        font-size: 14px;
        font-family: PingFangSC-Regular, PingFang SC;
        font-weight: 400;
        color: #666666;
        height: 78px;
      }
    }

    .vsData_item {
      width: 278px;
      background: #ffffff;
      border-radius: 5px;
      display: flex;
      margin-right: 12px;
      flex-direction: column;
      justify-content: space-between;

      .vs_data {
        display: flex;
        flex: 2;
        align-items: center;
        justify-content: space-between;


        .vs_status {
          font-size: 28px;
          font-family: PingFangSC-Regular, PingFang SC;
          font-weight: 400;
          color: #666666;
          display: flex;
          flex-direction: column;
        }

        img {
          width: 58px;
          height: 58px;
          border-radius: 50%;
          border: 1px solid rgba(0, 0, 0, 0.1);
        }

        .teamitem {
          display: flex;
          flex-direction: column;
          padding: 22px 10px 18px;
          box-sizing: border-box;

          span {
            margin-top: 14px;
            font-size: 14px;
            font-family: PingFangSC-Medium, PingFang SC;
            font-weight: 600;
            color: #333333;
          }
        }
      }

      .vs_title {
        box-sizing: border-box;
        display: flex;
        padding: 10px;
        justify-content: space-between;
        font-size: 14px;
        font-family: PingFangSC-Regular, PingFang SC;
        align-items: center;
        border-bottom: 1px solid rgba(0, 0, 0, 0.2);
      }
    }
  }

  .home_banner {
    display: flex;
    justify-content: center;

    .banner_xuanchan {
      cursor: pointer;
      margin-top: 20px;
      border-radius: 4px;
      overflow: hidden;
      max-width: 1200px;
    }
  }

  .home-right {
    display: flex;
    align-items: center;
    background: #f7f8fa;
    margin-top: 50px;

    .centerData {
      display: flex;
      flex-direction: column;
      justify-content: center;
      align-items: center;
      width: 100%;

      .hots {
        .home-right-li {
          margin-bottom: 0 !important;
        }
      }

      .tuijian {

        .nobottom {
          margin-bottom: 0 !important;
        }
      }

      .mylista {
        display: flex;
        justify-content: space-between;
        width: 100%;
        max-width: 1200px;

        .rankingList {
          width: 392px;
          height: 496px;
          background: #ffffff;
          box-shadow: 0px 0px 10px 0px rgba(46, 48, 52, 0.1);
          border-radius: 6px;

          .line-tabs {
            position: absolute;
            height: 4px;
            width: 33px;
            position: absolute;
            transition: all 0.3s;
            // border: 1px solid #721edc;
            border-radius: 15px;
            bottom: 0px;
            background: linear-gradient(90deg,
                rgba(137, 118, 255, 0.4) 0%,
                rgba(192, 182, 255, 0.1) 100%);
          }

          .rankTitle {
            width: 291px;
            height: 40px;
            position: relative;

            .ranklist {
              display: flex;
              flex-direction: column;
              padding: 12px;

              .rankItem {
                display: flex;
                align-items: center;
                margin-bottom: 12px;
                cursor: pointer;

                .hotValue {
                  flex: 2;
                  display: flex;
                  justify-content: flex-end;
                  font-size: 12px;
                  font-family: PingFangSC-Regular, PingFang SC;
                  font-weight: 400;
                  color: #666666;
                }

                .attention_user {
                  flex: 2;
                  display: none;
                  justify-content: flex-end;
                  font-size: 12px;

                  .box_attentions {
                    border: 1px solid rgba(192, 182, 255, 0.3);
                    padding: 2px 6px;
                    border-radius: 6px;
                    color: salmon;
                  }
                }

                .rankitem_name {
                  // height: 14px;
                  max-width: 82px;
                  font-size: 14px;
                  font-family: PingFangSC-Regular, PingFang SC;
                  font-weight: 400;
                  color: #333333;
                }

                .ready_live {
                  font-size: 10px;
                  margin-left: 4px;
                  transform: translateY(3px);
                  color: salmon;

                  img {
                    width: 36px;
                    height: auto;
                  }
                }

                .rankItem_header {
                  margin: 0 4px;
                  position: relative;

                  img {
                    border-radius: 50%;
                    width: 28px;
                    height: 28px;
                  }

                  .live_center {
                    position: absolute;
                    width: 15px;
                    bottom: 4px;
                    right: 1px;
                    height: 15px;

                    img {
                      width: 15px;
                      height: 15px;
                    }
                  }
                }

                .ranknumber {
                  display: flex;
                  margin: 0 4px;

                  img {
                    width: 14px;
                    height: 21px;
                  }
                }

                .rankitem_grade {
                  margin-left: 4px;

                  img {
                    width: 27px;
                    height: 12px;
                  }
                }
              }

              .rankItem:hover {
                background-color: rgba(192, 182, 255, 0.2);
                transition: all 0.2s;
                .attention_user {
                  display: flex !important;
                }
              }

              .rankItem:last-child {
                margin-bottom: 0 !important;
              }
            }

            .changetabs {
              display: flex;
              justify-content: space-between;
            }

            .titemActive {
              color: #721edc !important;
            }

            .titem {
              cursor: pointer;
              width: 50%;
              height: 40px;
              border-radius: 6px;
              line-height: 40px;
              text-align: center;
              font-size: 16px;
              font-family: PingFangSC-Regular, PingFang SC;
              font-weight: 400;
              color: #666666;
            }

            .titem:hover {
              color: #721edc;
            }
          }
        }
      }

      .home-right-center {
        user-select: none;
        display: flex;
        justify-content: flex-start;
        align-items: center;
        max-width: 1200px;
        width: 100%;
        text-align: left;
        padding: 26px 0 16px;

        .moredata {
          flex: 2;
          display: flex;
          align-items: center;
          justify-content: flex-end;

          .more_icon {
            width: 14px;
            height: 20px;
          }

          .title {
            cursor: pointer;
            font-size: 14px;
            margin-right: 2px;
            height: 20px;
            font-family: PingFangSC-Regular, PingFang SC;
            font-weight: 400;
            color: #666666;
          }

          .title:hover {
            color: $colorHover;
          }

          img {
            width: 14px;
            height: 14px;
          }
        }

        .title_img {
          margin-right: 6px;
          width: 32px;
          height: 32px;

          img {
            width: 32px;
            height: 32px;
          }
        }

        .title {
          font-size: 20px;
          font-family: PingFangSC-Medium, PingFang SC;
          font-weight: 500;
          color: #333333;
        }
      }
    }
  }

  .home-right-top {
    background-repeat: no-repeat;
    background-position: top;
    /* background-size: cover; */
    min-height: 600px;
    cursor: pointer;
    display: flex;
    flex-direction: column;
    align-items: center;

    .tabs_header {
      display: flex;
      justify-content: flex-start;
      width: 100%;
      max-width: 1200px;
      align-self: center;

      .itemtabs {
        min-width: 101px;
        text-align: center;
        margin-top: 20px;
        height: 36px;
        line-height: 36px;
        color: #fff;
        background-color: rgba(0, 0, 0, 0.4);
        font-size: 14px;
        font-family: PingFangSC-Regular, PingFang SC;
        font-weight: 400;
        border-right: 1px solid rgba(0, 0, 0, 0.8);
        color: #ffffff;
      }

      .activetabs {
        background: linear-gradient(270deg,
            #8e41ef 0%,
            rgba(146, 67, 243, 0.5) 100%) !important;
      }
    }

    .video_hander {
      display: flex;
      justify-content: center;
      align-items: flex-start;
    }
  }

  .bofangqi:hover{
      .videoMovieinto{
          display:block !important;

      }
  }
  .bofangqi {
    width: 998px;
    height: 564px;
    margin: 0 0 20px;
    border-radius: 6px;
    margin-right: 10px;
    position: relative;

    .videoMovieinto {
      display: none;
      color: #1076e9;
      z-index: 999;
      text-align: center;
      background: rgba(51, 51, 51, 0.5);
      position: absolute;
      width: 200px;
      height: 56px;
      line-height: 56px;
      // background-color: #111;
      opacity: 0.7;
      border: 1px solid #1076e9;
      border-radius: 30px;
      left: calc(50% - 100px);
      top: calc(50% - 47px);
      font-size: 20px;
      font-weight: 700;
      cursor: pointer;
    }
  }

  .bofangqi .prism-player .prism-info-display {
    z-index: -1;
  }

  .bofangqi .prism-player .prism-loading {
    z-index: -1;
  }

  .bofangqi .prism-player .prism-ErrorMessage {
    z-index: 9;
  }

  .bofangqi .prism-player .prism-controlbar {
    z-index: 9;
  }

  .banner_swipers {
    width: 796px;
    height: 238px;
    border-radius: 6px;
  }
  .myhotVideo{
    display: flex;
    width: 100%;
    justify-content: center;
    height: 496px;
    border-radius: 6px;
    .myhotContent{
      max-width: 1200px;
      display: flex;
      /* border: 1px solid red; */
      width: 100%;
      /* background: #FFFFFF; */
    }
  }

    .home-right-bottom {
      display: flex;
      flex-flow: row wrap;
      justify-content: flex-start !important;
      /deep/ .home-right-li {
        width: 291px;
        height: 238px;
        background: #ffffff;
        box-shadow: 0px 2px 10px 0px rgba(46, 48, 52, 0.1);
        border-radius: 6px;
        box-sizing: border-box;
        list-style-type: none;
        background-color: $bgNav;
        overflow: hidden;
        transition: all 0.3s;

        .image-slot {
          img {
            width: 291px;
            height: 165px;
          }
        }
        .home-right-info {
          height: 168px;
          img {
            width: 291px;
            height: 165px;
          }
        }
        .home-right-div-title {
          font-size: 14px;
          width: 265px;
          .attention {
            cursor: pointer;
            display: block;
            padding: 6px 18px;
            border-radius: 18px;
            background: linear-gradient(270deg, #F75325 0%, #ED1010 100%);
            color: #fff;
            font-size: 14px;
            text-align: center;
          }

          .careOk {
            cursor: pointer;
            display: block;
            padding: 6px 18px;
            border-radius: 18px;
            background: rgb(231, 231, 231);
            color: #fff;
            font-size: 14px;
            text-align: center;
          }
        }
      }

      .home-right-bottomItem:nth-child(4n) {
        /deep/ .home-right-li {
          margin-right: 0 !important;
        }
      }

      .attention,
      .careOk {
        display: none;
      }
    }

  .home-right-top div>img {
    width: 100%;
    background-size: 100% 100%;
    /* height: auto+15px; */
  }

  .home-right-top ul {
    width: 190px;
    display: flex;
    background: #000;
    flex-direction: column;
  }

  .home-right-top ul>li {
    width: 190px;
    height: 106px;
    background: #333;
    border: 0.5px solid rgba(239, 239, 239, 0.2);
    border-radius: 6px;
    cursor: pointer;
    opacity: 0.5;
    list-style-type: none;
    margin-bottom: 8px;
    box-sizing: border-box;
  }

  .home-right-top ul>li:last-child {
    margin-bottom: 0 !important;
  }

  .home-right-top ul>li:hover {
    border: 1px solid #672dd4;
    opacity: 1;
  }

  .home-right-top ul>li>img {
    width: 100%;
    height: 100%;
    background-size: 100% 100%;
  }

  .home-right-div {
    /* height: 30%; */
    display: flex;
    height: 80px;
    flex-flow: column wrap;
    box-sizing: border-box;
    padding: 8px;

    .hotValue {
      display: flex;
      margin-top: 8px;
    }

    .video_list_img {
      width: 22px;
      height: 22px;
      margin-right: 4px;
      border-radius: 50%;
      overflow: hidden;

      img {
        width: 22px;
        height: 22px;
      }
    }
  }

  .home-right-div>a {
    text-decoration: none;
  }

  .home-right-div-title {
    font-size: 16px;
    font-family: PingFangSC-Medium, PingFang SC;
    font-weight: 500;
    color: #333333;
    width: 280px;
  }
</style>



// WEBPACK FOOTER //
// src/components/HelloWorld.vue